// Third party
import {
  RegionsListAllFeaturedDocument,
  RegionsListAllFeaturedQuery,
} from '@gql';

// Utils
import { createApolloClient } from '../apollo-node-client';
import { notEmpty } from '../not-empty';

export const imperativeNodeDestinationsQuery = async () => {
  const apolloClient = createApolloClient();

  const result = await apolloClient.query<RegionsListAllFeaturedQuery>({
    query: RegionsListAllFeaturedDocument,
    variables: { page: 1, pageSize: 20 },
  });

  const destinations = result.data.regionsListAllFeatured.entries
    .map((region) => {
      if (region.name && region.imageUrl && region.placeId) {
        return {
          name: region.name,
          imageUrl: region.imageUrl,
          placeId: region.placeId,
        };
      } else {
        return null;
      }
    })
    .filter(notEmpty);

  return destinations;
};
